import React, { useEffect } from "react";
import { ConfigProvider } from 'antd';
import { useKeycloak } from "@react-keycloak/web";
import { useDispatch } from "react-redux";
import { useTheme } from './contexts/ThemeContext';
import { getThemeConfig } from './styles/antd-theme';
import RoutesComponent from "./routes/RoutesComponent";
import LicenseExpiredBanner from "./components/LicenseExpiredBanner";
import { fetchLicenseStatus } from "./redux/slieces/licenseSlice";

const AppContent = () => {
  const { keycloak, initialized } = useKeycloak();
  const { isDark } = useTheme();
  const dispatch = useDispatch();

  useEffect(() => {
    if (initialized && keycloak?.authenticated) {
      dispatch(fetchLicenseStatus());
    }
  }, [initialized, keycloak?.authenticated, dispatch]);

  if (!initialized) {
    return (
      <ConfigProvider theme={getThemeConfig(isDark)}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'var(--bg-primary)',
          color: 'var(--text-primary)',
          fontSize: '18px'
        }}>
          Loading authentication...
        </div>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider theme={getThemeConfig(isDark)}>
      <LicenseExpiredBanner />
      <RoutesComponent />
    </ConfigProvider>
  );
};

export default AppContent; 
/* const AppContent = () => {
  return <div style={{ padding: 40, fontSize: 24 }}>✅ App is rendering</div>;
};

export default AppContent; */
